import { SearchOptions, SearchResponse } from '@algolia/client-search';
import { Injectable } from '@angular/core';
import { environment } from '@environment';
import { PoleEmploiDepartment } from '@models/pole-emploi/department';
import { AlgoliaClientService } from '@wizbii/algolia';
import { SearchIndex } from 'algoliasearch';
import { from, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SearchDepartementsWebservice {
  private readonly index: SearchIndex;

  constructor(private readonly algoliaClientService: AlgoliaClientService) {
    this.index = this.algoliaClientService.client.initIndex(environment.algolia.index.poleEmploiDepartments);
  }

  getDepartments(query: string, searchParams?: SearchOptions): Observable<SearchResponse<PoleEmploiDepartment>> {
    return from(this.index.search<PoleEmploiDepartment>(query, searchParams));
  }
}
